"use client";
import React, { useState } from "react";
import styles from "./Accordian.module.css";

export interface AccordianProps {
  title: string;
  content: string;
}

const Accordian = ({ title, content }: AccordianProps) => {
  const [open, setOpen] = useState<boolean>(false);

  const toggle = () => setOpen(!open);

  return (
    <div data-testid="accordian" className={styles.container}>
      <div
        className={styles.title}
        onClick={toggle}
        style={{ borderBottom: open ? "1px solid #66686A" : "none" }}
      >
        <h4>{title}</h4>
        <div className={styles.icon_container}>
          {!open ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path d="M6 6V0H8V6H14V8H8V14H6V8H0V6H6Z" fill="#5440F0" />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.80666 8.02999C1.66583 8.17082 1.47483 8.24994 1.27566 8.24994C1.0765 8.24994 0.885492 8.17082 0.744662 8.02999C0.603832 7.88916 0.524715 7.69816 0.524715 7.49899C0.524715 7.29983 0.603832 7.10882 0.744662 6.96799L5.46966 2.24399C5.61029 2.10354 5.80091 2.02465 5.99966 2.02465C6.19841 2.02465 6.38904 2.10354 6.52966 2.24399L11.2547 6.96799C11.3955 7.10882 11.4746 7.29983 11.4746 7.49899C11.4746 7.69816 11.3955 7.88916 11.2547 8.02999C11.1138 8.17082 10.9228 8.24994 10.7237 8.24994C10.5245 8.24994 10.3335 8.17082 10.1927 8.02999L5.99966 3.83699L1.80666 8.02999Z"
                fill="#5440F0"
              />
            </svg>
          )}
        </div>
      </div>
      {open && <p className={styles.content}>{content}</p>}
    </div>
  );
};

export default Accordian;
